import React from "react";
import PopupBodyItem from "../../Helpers/Popup/PopupParts/PopupBodyItem";
import { formatDate } from "../../../JsHelpers/DateFormat";
import trans from "../../../utils";

export default function CustomerLocation({ values = {} }) {
	const getValue = (value, defaultValue = "-----") =>
		value ? value : defaultValue;

	const { address = "", country = "", city = "" } = values;

	return (
		<div>
			<p className="fs-16 fw-700 brand-700 text-uppercase">
				{trans("Customer Location")}
			</p>
			<div className="row">
				<div className="col-lg-12">
					<div className="display-border">
						<PopupBodyItem title={trans("address")} item={getValue(address)} />
					</div>
				</div>
				<div className="col-lg-6">
					<div className="display-border">
						<PopupBodyItem
							title={trans("country")}
							item={trans(getValue(country))}
						/>
					</div>
				</div>
				<div className="col-lg-6">
					<div className="display-border">
						<PopupBodyItem title={trans("city")} item={trans(getValue(city))} />
					</div>
				</div>
			</div>
		</div>
	);
}
